// extracted by mini-css-extract-plugin
module.exports = {"InputSearch":"styles_InputSearch__BCv1l","InputSearchButton":"styles_InputSearchButton__19BGf"};